import React from 'react'
import { withRouter } from 'next/router'
import styled from 'styled-components'
import { connect } from 'react-redux'
import withSidebar from '../../lib/withSidebar'
import DataDirectory from '../../components/DataDirectory'
import ContextPane from '../../components/ContextPane'
import SecureContent from '../../components/Page/SecureContent'
import ReportWindow from '../../components/ReportWindow'
import {
  loadInitialElements,
  setCurrentElement,
  clearCurrentElement,
  trackReportVisit,
} from '../../store/actions'

const ContainerDiv = styled.div`
  height: 100%;
  width: 100%;
`

class ElementView extends React.Component {
  componentDidMount() {
    const { elementId } = this.props.router.query
    this.props.dispatch(loadInitialElements(elementId))
    this.props.router.onRouteChangeComplete = () => this.updateElement()
  }

  componentDidUpdate(prevProps) {
    const nextElementId = this.props.router.query.elementId
    const prevElement = this.props.currentElement
    const prevElementId = prevElement ? prevElement.uuid : null
    if (nextElementId !== prevElementId) {
      this.updateElement()
    }
  }

  updateElement = () => {
    const elementId = this.props.router.query.elementId
    if (elementId) {
      this.props.dispatch(setCurrentElement(elementId))
    } else {
      this.props.dispatch(clearCurrentElement())
    }
  }

  trackReportView = elementId => {
    this.props.dispatch(trackReportVisit(elementId))
  }

  render() {
    const DataDirectorySidebar = withSidebar(DataDirectory, 'DATA_DIRECTORY', 'dataDirectory')
    const ContextPaneSidebar = withSidebar(ContextPane, 'CONTEXT_PANE', 'contextPane')
    return (
      <SecureContent>
        <DataDirectorySidebar left showByDefault />
        <ReportWindow
          url={this.props.reportWindowUrl}
          leftSidebar
          rightSidebar
          tracker={this.trackReportView}
        />
        <ContextPaneSidebar />
      </SecureContent>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    currentElement: state.dataDirectory.currentElement,
    reportWindowUrl: state.dataDirectory.reportWindowUrl,
    ...ownProps,
  }
}
export default withRouter(connect(mapStateToProps)(ElementView))
